import { render, staticRenderFns } from "./categorySlider.vue?vue&type=template&id=923613fc&scoped=true&"
import script from "./categorySlider.vue?vue&type=script&lang=js&"
export * from "./categorySlider.vue?vue&type=script&lang=js&"
import style0 from "./categorySlider.vue?vue&type=style&index=0&id=923613fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923613fc",
  null
  
)

export default component.exports